import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { colors } from "../../../Shared/colors";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { useAddClientLeadTaskMutation } from "../../../features/taskSlice";
import { Puff } from "react-loader-spinner";
import { toast, Toaster } from "react-hot-toast";
import {
  useGetAllProjectsQuery,
  useGetSingleProjectQuery,
} from "../../../features/projectSlice";
import { useLazyGetInventoryByProjectIdQuery } from "../../../features/InventorySlice";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Banks } from '../../../Shared/Banks'
import moment from 'moment-timezone';

export const AddNewLeadsThird = ({ client, lead, reset }) => {
  const [subType, setsubType] = useState();

  const [tokenDownPayment, settokenDownPayment] = useState(false);

  const [loading, setloading] = useState(false);

  const [closedLost, setclosedLost] = useState(false);

  const [doNothing, setdoNothing] = useState(false);

  //   const today = new Date();
  //   const numberOfDaysToAdd = 0;
  //   const date = today.setDate(today.getDate() + numberOfDaysToAdd);
  //   const defaultDate = new Date(date).toISOString().split("T")[0];

  // const minNumberOfDaysToAdd = -1;
  // const newMinDate = new Date(today.setDate(today.getDate() + minNumberOfDaysToAdd)).toISOString().split("T")[0];

  // useEffect(() => {
  //   setminDate(newMinDate);
  // }, [newMinDate]);

  //   useEffect(() => {
  //     setmaxDate(defaultDate)
  //   }, [defaultDate])
  const today = moment();
  const defaultDate = today.format('YYYY-MM-DDTHH:mm');
  const newMinDate = today.clone().subtract(1, 'days').format('YYYY-MM-DDTHH:mm');

  const [task, settask] = useState({
    currentTaskType: "",
    currentSubTypeTask: "",
    completedDate: defaultDate,
    reason: "",
    comment: "",
    nextTaskType: "",
    deadline: "",
    DProjectID: "",
    DTprojectBlockName: "",
    invenID: "",
    ammount: "",
    paymentMode: "",
    bankName: "",
    transactionNo: "",
    recieptNo: "",
    depositeDate: "",
    status: "",
    attachment: "",
    approvedPayment: "",
  });

  const [addClientLeadTask, { isLoading }] = useAddClientLeadTaskMutation();

  let { data: project } = useGetAllProjectsQuery();

  let { data: singleProject } = useGetSingleProjectQuery(task.DProjectID);

  const [trigger, { data: inventory }] = useLazyGetInventoryByProjectIdQuery();

  useEffect(() => {
    if (singleProject) {
      setloading(false);
    }
  }, [singleProject]);

  useEffect(() => {
    if (task.DProjectID || task.DTprojectBlockName) {
      const project = task.DProjectID;
      const block = task.DTprojectBlockName;
      trigger({ project, block });
    }
  }, [task.DProjectID, task.DTprojectBlockName, trigger]);

  let inventoryData = [];
  inventory?.forEach((inven) => {
    if (inven.status === "Available") {
      inventoryData.push({
        unitNo: inven.unitNo,
        id: inven._id,
      });
    }
  });

  const handleProject = (e) => {
    let { name, value } = e.target;
    setloading(true);
    settask({ ...task, DTprojectBlockName: "" });
    settask({ ...task, [name]: value });
  };

  let handleChange = (e) => {
    let { name, value } = e.target;
    if (name === "nextTaskType") {
      setdoNothing(false);
      if (value === "doNothing") {
        setdoNothing(true);
      }
    }
    settask({ ...task, [name]: value });
  };

  const handleFileChange = (e) => {
    const { name } = e.target;
    settask((prevstate) => ({
      ...prevstate,
      [name]: e.target.files[0],
    }));

    e.target.files = "";
  };

  const handleType = (e) => {
    if (e.target.value === "Call") {
      setsubType([
        "SMS",
        "Call connected",
        "Call Not Connected",
        "Whatsapp",
        "Followed Up",
      ]);
    } else if (e.target.value === "Meeting") {
      setsubType(["Vedio Meeting", "Head Office Meeting", "Outdoor", "Site", "Walk In"]);
    } else if (e.target.value === "Sales") {
      setsubType([
        "Token Payment",
        "CLosed (Won)",
        "Closed (Lost)",
        "Complete Down Payment",
      ]);
    }
    handleChange(e);
  };

  const handleSubtype = (e) => {
    settokenDownPayment(false);
    setclosedLost(false);
    if (
      e.target.value === "Token Payment" ||
      e.target.value === "Complete Down Payment"
    ) {
      settokenDownPayment(true);
    }
    if (e.target.value === "Closed (Lost)") {
      setclosedLost(true);
    }
    handleChange(e);
  };

  const handleSave = () => {
    var formdata = new FormData();
    const completedDate = moment(task.completedDate).utc().format('YYYY-MM-DDTHH:mm:ss');

    formdata.append("fullName", client.fullName);
    formdata.append("gender", client.gender);
    formdata.append("fatherName", client.fatherName);
    formdata.append("affiliate", client.affName)
    formdata.append("cnic", client.cnic);
    formdata.append("passportNo", client.passportNo);
    formdata.append("email", client.email);
    formdata.append("landLineNumber", client.landline);
    formdata.append("country", client.country);
    formdata.append("dob", client.dob);
    formdata.append("phoneNo", JSON.stringify(client.phoneNo));
    formdata.append("clientType", client.clientType);
    formdata.append("clientOccupation", client.clientOccupation);
    formdata.append("clientRating", client.clientRating);
    formdata.append("buyingIntent", client.buyingIntent);
    formdata.append("leadInterestedProjectID", lead.leadInterestedProjectID);
    formdata.append("classification", lead.classification);
    formdata.append("propertyType", lead.propertyType);
    formdata.append("subType", lead.subType);
    formdata.append("source", lead.source);
    formdata.append("budgetPer", lead.budgetPer);
    formdata.append("minPrice", lead.minPrice);
    formdata.append("maxPrice", lead.maxPrice);
    formdata.append("landArea", lead.landArea);
    formdata.append("beds", lead.beds);
    formdata.append("baths", lead.baths);
    formdata.append("constructionStatus", lead.constructionStatus);
    formdata.append("subject", lead.subject);
    formdata.append("leadmessage", lead.leadmessage);
    formdata.append("leadcomment", lead.leadcomment);
    formdata.append("currentTaskType", task.currentTaskType);
    formdata.append("currentSubTypeTask", task.currentSubTypeTask);
    formdata.append("completedDate", completedDate);
    formdata.append("reason", task.reason);
    formdata.append("comment", task.comment);
    formdata.append("nextTaskType", task.nextTaskType);
    formdata.append("deadline", task.deadline);
    formdata.append("attachment", task.attachment);
    formdata.append("DProjectID", task.DProjectID);
    formdata.append("DTprojectBlockName", task.DTprojectBlockName);
    formdata.append("invenID", task.invenID);
    formdata.append("ammount", task.ammount);
    formdata.append("paymentMode", task.paymentMode);
    formdata.append("bankName", task.bankName);
    formdata.append("transactionNo", task.transactionNo);
    formdata.append("recieptNo", task.recieptNo);
    formdata.append("depositeDate", task.depositeDate);
    formdata.append("status", task.status);
    formdata.append("approvedPayment", task.approvedPayment);
    addClientLeadTask(formdata)
      .unwrap()
      .then((res) => {
        toast.success("client lead and task created successfully");
        settask({
          currentTaskType: "",
          currentSubTypeTask: "",
          completedDate: "",
          reason: "",
          comment: "",
          nextTaskType: "",
          deadline: "",
          DProjectID: "",
          DTprojectBlockName: "",
          invenID: "",
          ammount: "",
          paymentMode: "",
          bankName: "",
          transactionNo: "",
          recieptNo: "",
          depositeDate: "",
          status: "",
          attachment: "",
          approvedPayment: "",
        });
        reset();
        window.location.reload();
      })
      .catch((error) => {
        toast.error(error?.data?.error?.message);
      });
  };



  return (
    <Main>
      <HeaderSection>
        <Heading>Create Task</Heading>
        <SubHeading>Complete the current task and set up the next task for this lead</SubHeading>
      </HeaderSection>
      
      <TaskContainer>
        <TaskColumn>
          <TaskHeader>
            <TaskTitle>Current Task</TaskTitle>
            <TaskSubtitle>Complete the current task details</TaskSubtitle>
          </TaskHeader>
          <FormField>
            <FieldLabel>
              Task Type <Required>*</Required>
            </FieldLabel>
            <SelectContainer>
              <select
                name="currentTaskType"
                id="currentTaskType"
                value={task.currentTaskType}
                onChange={handleType}
              >
                <option value="" disabled selected>
                  Select Task Type
                </option>
                <option value="Call">Call</option>
                <option value="Meeting">Meeting</option>
                {/* <option value="Sales">Sales</option> */}
              </select>
            </SelectContainer>
          </FormField>
          <FormField>
            <FieldLabel>
              Task Sub-Type <Required>*</Required>
            </FieldLabel>
            <SelectContainer>
              <select
                name="currentSubTypeTask"
                id="currentSubTypeTask"
                value={task.currentSubTypeTask}
                onChange={handleSubtype}
              >
                <option value="" selected>
                  Select Sub-Type
                </option>
                {subType?.map((ls) => (
                  <option value={ls} key={ls}>
                    {ls}
                  </option>
                ))}
              </select>
            </SelectContainer>
          </FormField>
          
          <FormField>
            <FieldLabel>
              Completed Date <Required>*</Required>
            </FieldLabel>
            <InputContainer>
              <input
                type="datetime-local"
                name="completedDate"
                id="completedDate"
                value={task.completedDate || defaultDate}
                onChange={handleChange}
                min={newMinDate}
                max={defaultDate}
              />
            </InputContainer>
          </FormField>
          {closedLost && (
            <FormField>
              <FieldLabel>
                Reason <Required>*</Required>
              </FieldLabel>
              <InputContainer>
                <input
                  type="text"
                  name="reason"
                  id="reason"
                  placeholder="Enter reason..."
                  value={task.comment}
                  onChange={handleChange}
                />
              </InputContainer>
            </FormField>
          )}
          
          {tokenDownPayment === false && (
            <>
              <FormField>
                <FieldLabel>
                  Comment <Required>*</Required>
                </FieldLabel>
                <TextAreaContainer>
                  <textarea
                    name="comment"
                    id="comment"
                    placeholder="Enter your comment here..."
                    value={task.comment}
                    onChange={handleChange}
                  />
                </TextAreaContainer>
              </FormField>
              {(task.currentTaskType === 'Meeting' || task.currentTaskType === "Sales" || task.currentSubTypeTask === "Whatsapp") && (
                <FormField>
                  <FieldLabel>
                    Attachment <Required>*</Required>
                  </FieldLabel>
                  <FileUploadContainer>
                    <FileUploadArea>
                      <FileUploadContent>
                        <AttachFileIcon />
                        <FileUploadText>Upload file here</FileUploadText>
                        <FileUploadButton htmlFor="attachment">
                          Choose File
                        </FileUploadButton>
                      </FileUploadContent>
                      {task.attachment && (
                        <UploadedFilePreview
                          src={URL.createObjectURL(task.attachment)}
                          alt="uploaded file"
                        />
                      )}
                    </FileUploadArea>
                    <input
                      type="file"
                      name="attachment"
                      id="attachment"
                      onChange={handleFileChange}
                    />
                  </FileUploadContainer>
                </FormField>
              )}
            </>
          )}
        </TaskColumn>
        
        <TaskColumn>
          <TaskHeader>
            <TaskTitle>Next Task</TaskTitle>
            <TaskSubtitle>Set up the next task for this lead</TaskSubtitle>
          </TaskHeader>
          
          <FormField>
            <FieldLabel>
              Next Task Type <Required>*</Required>
            </FieldLabel>
            <SelectContainer>
              <select
                name="nextTaskType"
                id="nextTaskType"
                value={task.nextTaskType}
                onChange={handleChange}
              >
                <option value="" disabled selected>
                  Select Next Task
                </option>
                <option value="doNothing">Do Nothing</option>
                <option value="followUp">Follow Up</option>
                <option value="contractedClient">Contracted Client</option>
                <option value="meetClient">Meet Client</option>
                <option value="recievePartialDownPayment">
                  Receive Partial Down Payment
                </option>
                <option value="recieveCompleteDownPayment">
                  Receive Complete Down Payment
                </option>
                <option value="arrangeMeeting">Arrange Meeting</option>
                <option value="receivetokenPayment">
                  Receive Token Payment
                </option>
              </select>
            </SelectContainer>
          </FormField>
          
          {doNothing === false && (
            <FormField>
              <FieldLabel>Deadline</FieldLabel>
              <InputContainer>
                <input
                  type="datetime-local"
                  name="deadline"
                  id="deadline"
                  value={task.deadline}
                  onChange={handleChange}
                  min={new Date().toISOString().slice(0, 16)}
                />
              </InputContainer>
            </FormField>
          )}
        </TaskColumn>
      </TaskContainer>
      
      {tokenDownPayment && (
        <PaymentSection>
          <PaymentHeader>
            <PaymentTitle>Payment Details</PaymentTitle>
            <PaymentSubtitle>Complete payment information</PaymentSubtitle>
          </PaymentHeader>
          
          <PaymentGrid>
            <FormField>
              <FieldLabel>
                Project <Required>*</Required>
              </FieldLabel>
              <SelectContainer>
                <select
                  name="DProjectID"
                  id="DProjectID"
                  onChange={handleProject}
                >
                  <option value="">Select Project</option>
                  {project?.map((pro) => (
                    <option key={pro._id} value={pro._id}>{pro.projectName}</option>
                  ))}
                </select>
              </SelectContainer>
            </FormField>
                {loading ? (
                  <Loader>
                    <Puff
                      height="40"
                      width="40"
                      radius={1}
                      color={colors.brown}
                      ariaLabel="puff-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                      visible={true}
                    />
                  </Loader>
                ) : null}
                {singleProject?.projectBlock?.length > 0 ? (
                  <InputFeild>
                    <h3>
                      Project Block: <b style={{ color: "red" }}>*</b>
                    </h3>
                    <div>
                      <select
                        name="DTprojectBlockName"
                        id="DTprojectBlockName"
                        onChange={handleChange}
                      >
                        <option value="">select</option>
                        {singleProject?.projectBlock?.map((pro) => (
                          <option value={pro.blockName}>{pro.blockName}</option>
                        ))}
                      </select>
                    </div>
                  </InputFeild>
                ) : null}
                <InputFeild>
                  <h3>
                    Unit: <b style={{ color: "red" }}>*</b>
                  </h3>
                  <div>
                    <select name="invenID" id="invenID" onChange={handleChange}>
                      <option value="" disabled selected>
                        Select
                      </option>
                      {inventoryData?.map((inven) => (
                        <option value={inven.id}>{inven.unitNo}</option>
                      ))}
                    </select>
                  </div>
                </InputFeild>
                <Heading>
                  Add Payment: <b style={{ color: "red" }}>*</b>
                </Heading>
                <InputFeild>
                  <h3>Amount:</h3>
                  <input
                    type="text"
                    name="ammount"
                    id="ammount"
                    value={task.ammount}
                    onChange={handleChange}
                  />
                </InputFeild>
                <InputFeild>
                  <h3>
                    Payment Mode: <b style={{ color: "red" }}>*</b>
                  </h3>
                  <div>
                    <select
                      name="paymentMode"
                      id="paymentMode"
                      onChange={handleChange}
                    >
                      <option value="" >
                        Select
                      </option>
                      <option value="Bank Transfer">Bank Transfer</option>
                    </select>
                  </div>
                </InputFeild>
                <BankInputFeild>
                  <h3>
                    Bank Name: <b style={{ color: "red" }}>*</b>
                  </h3>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={Banks}
                    value={task.bankName}
                    onChange={(event, newvalue) => settask({ ...task, bankName: newvalue })}
                    sx={{ width: '100%', border: `1px solid ${colors.inputBorderWhite}`, borderRadius: '5px' }}
                    renderInput={(params) => (
                      <TextField {...params} sx={{ backgroundColor: `${colors.inputWhite}` }} />
                    )}
                  />
                </BankInputFeild>
                <InputFeild>
                  <h3>
                    Transaction No: <b style={{ color: "red" }}>*</b>
                  </h3>
                  <input
                    type="text"
                    name="transactionNo"
                    id="transactionNo"
                    value={task.transactionNo}
                    onChange={handleChange}
                  />
                </InputFeild>
                <InputFeild>
                  <h3>
                    Reciept No: <b style={{ color: "red" }}>*</b>
                  </h3>
                  <input
                    type="text"
                    name="recieptNo"
                    id="recieptNo"
                    value={task.recieptNo}
                    onChange={handleChange}
                  />
                </InputFeild>
                <InputFeild>
                  <h3>
                    Deposite Date: <b style={{ color: "red" }}>*</b>
                  </h3>
                  <div>
                    <input
                      type="date"
                      name="depositeDate"
                      id="depositeDate"
                      value={task.depositeDate}
                      onChange={handleChange}
                    />
                  </div>
                </InputFeild>
                <InputFeild>
                  <h3>
                    Attach Payment Proof: <b style={{ color: "red" }}>*</b>
                  </h3>
                  <span>
                    <p>upload file here</p>
                    <label htmlFor="approvedPayment">
                      <AttachFileIcon /> Upload
                    </label>
                    {task.approvedPayment && (
                      <UploadedFile
                        src={URL.createObjectURL(task.approvedPayment)}
                        alt="uploaded file"
                      />
                    )}
                  </span>
                  <input
                    type="file"
                    name="approvedPayment"
                    id="approvedPayment"
                    onChange={handleFileChange}
                  />
                  <p>
                    Note: Invalid payment proof will result in cancellation of
                    payment and inventory will released immediately.
                  </p>
                </InputFeild>
                <InputFeild>
                  <h3>
                    Comment: <b style={{ color: "red" }}>*</b>
                  </h3>
                  <textarea
                    name="comment"
                    id="comment"
                    placeholder="type here..."
                    value={task.comment}
                    onChange={handleChange}
                  ></textarea>
                </InputFeild>
                <FixedContainer>
                  <Price>
                    <h4>Unit Price:</h4>
                    <p>PKR 1230000</p>
                  </Price>
                  <InputFeild>
                    <h3>Unit Status:</h3>
                    <div>
                      <select
                        name="status"
                        id="status"
                        value={task.status}
                        onChange={handleChange}
                      >
                        <option value="downPayment" disabled selected>
                          downPayment
                        </option>
                      </select>
                    </div>
                  </InputFeild>
                  <InputFeild>
                    <h3>Unit Discount</h3>
                    <input
                      type="text"
                      value={"0"}
                      name="uniDiscount"
                      id="unitDiscount"
                      disabled
                    />
                  </InputFeild>
                  <InputFeild>
                    <h3>Deal Price</h3>
                    <input
                      type="text"
                      value={"342324"}
                      name="dealPrice"
                      id="dealPrice"
                      disabled
                    />
                  </InputFeild>
                  <Price>
                    <h4>Due Amount:</h4>
                    <p>PKR 1230000</p>
                  </Price>
                </FixedContainer>
          </PaymentGrid>
        </PaymentSection>
      )}
      
      <ActionSection>
        <ActionButtons>
          <CancelButton onClick={reset}>
            Cancel
          </CancelButton>
          <SaveButton
            onClick={handleSave}
            disabled={isLoading}
          >
            {isLoading ? 'Saving...' : 'Save Task'}
          </SaveButton>
        </ActionButtons>
      </ActionSection>
      <Toaster />
    </Main>
  );
};

const Main = styled.div`
  width: 100%;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  padding: 2.5rem;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${colors.brown} 0%, #8B4513 100%);
  }
`;

const HeaderSection = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #f1f3f4;
`;

const Heading = styled.h1`
  font-size: 2.2rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 0.75rem 0;
  letter-spacing: -0.5px;
`;

const SubHeading = styled.p`
  color: #6c757d;
  font-size: 1.1rem;
  margin: 0;
  font-weight: 400;
  line-height: 1.5;
`;

const TaskContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const TaskColumn = styled.div`
  background: #f8f9fa;
  border-radius: 12px;
  padding: 2rem;
  border: 1px solid #e9ecef;
`;

const TaskHeader = styled.div`
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #dee2e6;
`;

const TaskTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 0.5rem 0;
`;

const TaskSubtitle = styled.p`
  color: #6c757d;
  font-size: 0.95rem;
  margin: 0;
`;

const FormField = styled.div`
  margin-bottom: 1.5rem;
`;

const FieldLabel = styled.label`
  display: block;
  font-size: 1rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0.5rem;
`;

const Required = styled.span`
  color: #dc3545;
  margin-left: 4px;
`;

const SelectContainer = styled.div`
  select {
    width: 100%;
    padding: 12px 16px;
    border: 2px solid #e9ecef;
    border-radius: 8px;
    font-size: 1rem;
    background: white;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 500;
    
    &:focus {
      border-color: ${colors.brown};
      box-shadow: 0 0 0 4px rgba(139, 69, 19, 0.1);
      outline: none;
    }
  }
`;

const InputContainer = styled.div`
  input {
    width: 100%;
    padding: 12px 16px;
    border: 2px solid #e9ecef;
    border-radius: 8px;
    font-size: 1rem;
    background: white;
    transition: all 0.3s ease;
    font-weight: 500;
    
    &:focus {
      border-color: ${colors.brown};
      box-shadow: 0 0 0 4px rgba(139, 69, 19, 0.1);
      outline: none;
    }
    
    &::placeholder {
      color: #adb5bd;
    }
  }
`;

const TextAreaContainer = styled.div`
  textarea {
    width: 100%;
    padding: 12px 16px;
    border: 2px solid #e9ecef;
    border-radius: 8px;
    font-size: 1rem;
    background: white;
    transition: all 0.3s ease;
    font-weight: 500;
    min-height: 100px;
    resize: vertical;
    font-family: inherit;
    
    &:focus {
      border-color: ${colors.brown};
      box-shadow: 0 0 0 4px rgba(139, 69, 19, 0.1);
      outline: none;
    }
    
    &::placeholder {
      color: #adb5bd;
    }
  }
`;

const FileUploadContainer = styled.div`
  input[type="file"] {
    display: none;
  }
`;

const FileUploadArea = styled.div`
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  padding: 1.5rem;
  background: white;
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:hover {
    border-color: ${colors.brown};
    background: rgba(139, 69, 19, 0.02);
  }
`;

const FileUploadContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  text-align: center;
`;

const FileUploadText = styled.p`
  color: #6c757d;
  font-size: 0.9rem;
  margin: 0;
  font-weight: 500;
`;

const FileUploadButton = styled.label`
  background: linear-gradient(135deg, ${colors.brown} 0%, #8B4513 100%);
  color: white;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(139, 69, 19, 0.3);
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(139, 69, 19, 0.4);
  }
`;

const UploadedFilePreview = styled.img`
  max-width: 100px;
  max-height: 100px;
  border-radius: 6px;
  margin-top: 0.5rem;
`;

const PaymentSection = styled.div`
  background: #f8f9fa;
  border-radius: 12px;
  padding: 2rem;
  border: 1px solid #e9ecef;
  margin-bottom: 2rem;
`;

const PaymentHeader = styled.div`
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #dee2e6;
`;

const PaymentTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 0.5rem 0;
`;

const PaymentSubtitle = styled.p`
  color: #6c757d;
  font-size: 0.95rem;
  margin: 0;
`;

const PaymentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
`;

const ActionSection = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 2rem;
  border-top: 1px solid #f1f3f4;
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 1rem;
`;

const CancelButton = styled.button`
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: #5a6268;
    transform: translateY(-1px);
  }
`;

const SaveButton = styled.button`
  background: linear-gradient(135deg, ${colors.brown} 0%, #8B4513 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(139, 69, 19, 0.3);
  
  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(139, 69, 19, 0.4);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const InputPart = styled.div`
  h3 {
    font-size: clamp(1.5em, 2vh, 3em);
  }
`;

const InputFeild = styled.div`
  width: 100%;
  h3 {
    color: ${colors.black};
    font-size: clamp(1em, 1vw, 2em);
    margin: 1em 0em;
  }
  p {
    color: ${colors.veryHot};
    margin-top: 0.5em;
  }
  div {
    position: relative;
    border: 1px solid ${colors.inputBorderWhite};
    border-radius: 6px;
    width: 100%;
    padding-right: 1em;
    background-color: ${colors.inputWhite};
    select,
    input[type="datetime-local"] {
      background-color: ${colors.inputWhite};
      width: 100%;
      padding: 1em 0em 1em 1em;
      outline: none;
      border: none;
      ::placeholder {
        color: ${colors.inputFeild};
      }
    }
  }
  input,
  textarea {
    border: 1px solid ${colors.inputBorderWhite};
    border-radius: 6px;
    background-color: ${colors.inputWhite};
    width: 100%;
    padding: 1em 0em 1em 1em;
    outline: none;
    ::placeholder {
      color: ${colors.inputFeild};
    }
  }
  span {
    background-color: ${colors.inputWhite};
    padding: 1em 0em 1em 1em;
    border-radius: 5px;
    border: 1px solid ${colors.inputBorderWhite};
    display: flex;
    position: relative;
    label {
      position: absolute;
      right: 3%;
      top: 50%;
      transform: translateY(-50%);
      background-color: ${colors.black};
      color: ${colors.white};
      padding: 0.5em 1em;
      border-radius: 5px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    p {
      font-size: clamp(1em, 1vh, 2em);
      color: ${colors.textMed};
    }
  }
  input[type="file"] {
    display: none;
  }
`;

const ButtonPart = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 15vh;
  button {
    padding: 1em 2em;
    border-radius: 5px;
    min-width: 8em;
    outline: none;
    border: none;
    background-color: ${colors.inputWhite};
    cursor: pointer;
  }
`;

const FixedContainer = styled.div`
  width: 100%;
  min-height: 3em;
  margin-top: 1em;
  background-color: ${colors.inputBorderWhite};
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 1em;
`;

const Price = styled.div`
  display: flex;
  p {
    margin-left: 2em;
  }
  margin-top: 1em;
`;

const Loader = styled.div`
  margin-top: 1em;
`;


const BankInputFeild = styled.div`
width: 100%;
h3 {
    color: ${colors.black};
    font-size: clamp(1em, 1vw, 2em);
    margin: 1em 0em;
  }
`

const UploadedFile = styled.img`
    border-radius: 50%;
    margin-left: 50%;
    width: 70px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
`